<nz-card>
  
  
    <app-search-filter [total]="queryParams.totalItems" (search$)="getValueSearch($event)">
      <div class="col-4">
        <div class="row">
          <div class="col-lg-12">
            <div class="d-md-flex">
              <nz-input-group [nzPrefix]="prefixTemplate">
                <input type="text" nz-input placeholder="Mã sản phẩm" [(ngModel)]="searchParams.code"
                  (ngModelChange)="eventSearchParams('code', searchParams.code)">
              </nz-input-group>
              <ng-template #prefixTemplate>
                <i nz-icon nzType="search" class="opacity-05"></i>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4"></div>
    </app-search-filter>
  
  <nz-divider></nz-divider>
  <nz-table #listViewTable [nzData]="list" [nzShowPagination]="false" [nzFrontPagination]="false">
    <thead>
    <tr>
      <th>Tên</th>
      <th>Mã sản phẩm</th>
      <th>NAV</th>
      <th>Tổng giá trị phát hành</th>
      <th>Ngày kết thúc phát hành</th>
      <th>Tổng giá trị</th>
      <th>Kích hoạt	</th>
      <th>Action</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of listViewTable.data; trackBy: trackId; index as index">
      <td>{{item.name}}</td>
      <td>{{item.code}}</td>
      <td>{{item.nav}}</td>
      <td>{{item.totalReleaseValue}}</td>
      <td>{{item.endDate}}</td>
      <td>{{item.totalValue}}</td>
      <td>{{item.status}}</td>
      <td>
        <button type="button" class="btn dropdown-toggle" data-toggle="dropdown">
           <i nz-icon nzType="menu" nzTheme="outline"></i>
          <span class="sr-only">Toggle Dropdown</span>
        </button>
        <div [ngClass]="(index > list.length - 3) && list.length > 3 && 'dropup'">
        <ul class="dropdown-menu" role="menu">
          <li><a href="#" class="ant-btn btn-edit"><i nz-icon nzType="edit" nzTheme="outline"></i><span>Edit</span></a></li>
          <li><a href="#" class="ant-btn btn-edit"><i nz-icon nzType="delete" nzTheme="outline"></i><span>Delete</span></a></li>
        </ul>
        </div>
      </td>
    </tr>
    </tbody>
  </nz-table>
  <div class="ant-table-pagination ant-pagination">
    <nz-pagination [nzPageIndex]="queryParams.page" [nzTotal]="queryParams.totalItems" [nzPageSize]="queryParams.size"
                   [nzShowTotal]="rangeTemplate" (nzPageIndexChange)="loadPage($event)"></nz-pagination>
    <ng-template #rangeTemplate let-range="range" let-total>
      {{ range[0] }} - {{ range[1] }} of {{ queryParams.totalItems }} items
    </ng-template>
  </div>
</nz-card>
